import React, { useEffect, useState } from 'react'
import { Row, Col } from 'rsuite'
import { requiredFiled, isValidators } from '../../../utils/ValidatorUtils'
import CustomIconMessageInfo from '../../../widgets/CustomIconMessageInfo'
import ErrorMessage from '../../message/errorMessage/ErrorMessage'
import DatePickerCustom from '../../datePicker/DatePickerCustom'
import moment from 'moment'
import { REQUEST_DATE_FORMAT } from '../../../constants/date'

export default function InputDateForm({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  index,
  onChange = () => {},
  ...props
}) {
  const keyName = props?.name || schema?.name
  const labelMdLg = props.labelMdLg || 24
  const inputMdlg = props.inputMdlg || 24
  const disabled = props.disabled || schema?.disabled || false
  const [inputValue, setInputValue] = useState(
    props.isValue ? props.value || '' : props.value || schema?.value || ''
  )
  //const placeholder = props.placeholder || schema?.hint || 'เลือก ' + schema?.label
  const startDateEnable = props.startDate || schema.limitDateStart || null
  const endDateEnable = props.endDate || schema.limitDateEnd || null

  useEffect(() => {
    if (props.isValue) {
      setInputValue(props.value || '')
    } else {
      setInputValue(props.value || schema?.value || '')
    }
  }, [props.value, schema])

  return (
    <>
      {schema && (
        <Row style={{ ...props.style }}>
          {errors[keyName] && (
            <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
              <ErrorMessage error={errors[keyName]} />
            </Col>
          )}

          {!props.hideLabel && schema.label && (
            <Col xs={24} sm={24} md={labelMdLg} lg={labelMdLg} style={{ marginTop: 10 }}>
              <p>{requiredFiled(schema.validators, `${schema.label} ${index || ''}`)}</p>
            </Col>
          )}
          {schema.description && (
            <Col xs={24} sm={24} md={labelMdLg} lg={labelMdLg} style={{ marginTop: 10 }}>
              <CustomIconMessageInfo style={{ marginBottom: 10 }} contents={schema.description} />
            </Col>
          )}
          <Col xs={24} sm={24} md={inputMdlg} lg={inputMdlg} style={{ marginTop: 5 }}>
            <Controller
              key={keyName}
              name={keyName}
              control={control}
              rules={isValidators(schema.validators)}
              defaultValue={inputValue}
              value={inputValue}
              render={(props) => {
                return (
                  <DatePickerCustom
                    {...props}
                    disabled={disabled}
                    value={inputValue ? moment(inputValue, REQUEST_DATE_FORMAT).toDate() : null}
                    onChange={(value) => {
                      let dateValue = value ? moment(value).format(REQUEST_DATE_FORMAT) : null
                      props.onChange(dateValue)
                      setInputValue(dateValue)
                      onChange(value)
                    }}
                    startDate={startDateEnable}
                    endDate={endDateEnable}
                    //disabledDate={props.disabledDate || undefined}
                  />
                )
              }}
            />
          </Col>
        </Row>
      )}
    </>
  )
}
